import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";
import { IUser } from "./types/_user";
const api = new APIClient();

const path = "/notifications";

const notificationApi = {
  getPushLogs(params: any): Promise<any> {
    const url = `${path}/logs`;
    return api.get(url, params);
  },

  getNotificationUsers(params: any): Promise<any> {
    const url = `${path}/users`;
    return api.get(url, params);
  },

  getManualPush(params: any): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}`;
    return api.get(url, params);
  },

  putManualSendStatus(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/${id}/cancel`;
    return api.put(url, dataForm);
  },

  createNotifications(params: any) {
    return api.post(path, params);
  },

  updateNotifications(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  getNotificationSettings(user_id: string | number, params?: any): Promise<any> {
    const url = `${path}/settings/${user_id}`;
    return api.get(url, params);
  },
};

export default notificationApi;
